import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PageProps, PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {PARTYCATEGORY, PARTYROLE} from "party/partyDomain";
import {loc} from "core/common/config/locales";

const gridLocation = 'partyHaulers';

@observer
export default class HaulerList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.party;
  static title = loc.i18n`Haulers`;
  static icon = 'truck';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("HaulerList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }




  render() {
    let {params, query} = this.props;


    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           multiUpdateSecurable={SECURABLE.partyGridUpdate} >
          <ZzFlatButtonRoute onGridToolbar routeName="partyDetail" params={{id: 'new'}} query={{partyCategory: PARTYCATEGORY.CO, roles:PARTYROLE.HAULER}} label="New Hauler" permission={PERMISSION.New}/>
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/party/page/haulerList.tsx